import React, { memo } from 'react';

import {
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from '@/components/shared/element/table';
import { Text } from '@/components/shared/element/text';
import { Box } from '@/components/shared/layout/box';
import type { IParts } from '@/types/shared/parts';

interface PartsTableProps {
  table: IParts['table'];
  size?: 'small' | undefined;
  dataTest?: string;
}

export const PartsTable = memo(
  ({ table, size, dataTest = 'popup_partsDetail' }: PartsTableProps) => {
    const isSmall = size === 'small';

    return (
      <Box
        test={{
          dataTest: dataTest + '_table',
        }}
      >
        <Table>
          {!!table?.head?.items && (
            <Thead size={size}>
              {table?.head.items.map((headItem, index: number) => (
                <Tr key={index}>
                  {headItem.item?.map((head, headIndex: number) => (
                    <Td
                      key={`${index}-${headIndex}`}
                      css={{ width: `${head.width}%` }}
                    >
                      <Text
                        variant="text-white"
                        font="bold"
                        size={
                          isSmall
                            ? 'text-base-2'
                            : {
                                '@initial': 'text-base-2',
                                '@sm': 'text-base',
                              }
                        }
                        wrap
                        dangerouslySetInnerHTML={{
                          __html: head.title ?? '',
                        }}
                      />
                    </Td>
                  ))}
                </Tr>
              ))}
            </Thead>
          )}

          {!!table?.body?.items && (
            <Tbody size={size === 'small' ? 'small' : undefined}>
              {table?.body.items.map((o, i) => (
                <Tr key={i}>
                  {o.item?.map((body, i) => {
                    const fontSize: any = isSmall
                      ? '2xs'
                      : { '@initial': '2xs', '@sm': 'sm' };

                    return (
                      <React.Fragment key={i}>
                        {i === 0 ? (
                          <Th key={i}>
                            <Text
                              css={{
                                pt: '$space-2',
                              }}
                              size={fontSize}
                              wrap
                              dangerouslySetInnerHTML={{
                                __html: body.title ?? '',
                              }}
                            />
                          </Th>
                        ) : (
                          <Td
                            key={i}
                            rowSpan={body.colspan ? body.colspan : undefined}
                          >
                            <Text
                              css={{
                                pt: '$space-2',
                              }}
                              size={fontSize}
                              variant={body.red ? 'text-red' : 'text-black'}
                              wrap
                              dangerouslySetInnerHTML={{
                                __html: body.title ?? '',
                              }}
                            />
                          </Td>
                        )}
                      </React.Fragment>
                    );
                  })}
                </Tr>
              ))}
            </Tbody>
          )}
        </Table>
      </Box>
    );
  }
);

PartsTable.displayName = 'SectionPartsItemPartsNote';
